import PropTypes from "prop-types"
import { get } from "lodash"
import { Table, TableHead, TableRow, TableCell } from "@mui/material"
import { DATE } from "helpers/shapes"
import { VIEW_TYPES } from "helpers/base"
import { numberFormatter } from "helpers/formatters/numbers"
import { useTrack } from "helpers/analytics"
import ContributorsOptions from "components/contributors-options"
import ContributorsSorting from "components/contributors-sorting"
import ContributorsTableContent from "components/contributors-table-content"
import ContributorsTableHead from "components/contributors-table-head"
import "./style.scss"

function RiskContributors({
  selectedContributorCategory,
  selectedContributorValue,
  viewType,
  data,
  showContributorCategory,
  hideContributorCategory,
  sort,
  sortOrder,
  openFactorProfile,
  openSecurityProfile,
  openCompositeSecurity,
  selectedGroup,
  showGroup,
  hideGroup,
  setGrouping,
  currentGrouping,
  groupedData,
  availableRollups,
  contributorsSummaryText,
  csvData,
  selectedOption,
  selectedGroupValue,
  showNotHeld,
  groupBy,
  groupsDropdownColumns,
  groupDropdownItems,
  page,
  setPage,
}) {
  const trackExcelDownload = useTrack({
    type: "composite-analyze-risk-contributors-download",
  })

  const onBackClick = selectedGroup ? hideGroup : hideContributorCategory
  const selectedOptionColor = get(selectedOption, "color")

  return <div className="contributors-details-wrapper">
    <ContributorsOptions
      contributorsSummaryText={contributorsSummaryText}
      availableRollups={availableRollups}
      setGrouping={setGrouping}
      currentGrouping={currentGrouping}
      selectedGroup={selectedGroup}
      csvData={csvData}
      showNotHeld={showNotHeld}
      groupBy={groupBy}
      trackExcelDownload={trackExcelDownload}
    />
    <Table className="contributors-details-table">
      <TableHead>
        <TableRow>
          <TableCell />
          <TableCell />
          <TableCell align="right" title="% Risk">% Risk</TableCell>
        </TableRow>
        <TableRow className="sorting-row">
          <ContributorsSorting label="Name" id="name" order={sortOrder} sort={sort} />
          <ContributorsSorting align="right" label={viewType === VIEW_TYPES.ABSOLUTE ? "% Equity" : "Active % Equity"} id="equity" order={sortOrder} sort={sort} />
          <ContributorsSorting align="right" label={viewType === VIEW_TYPES.ABSOLUTE ? "Absolute" : "Active"} id="viewType" order={sortOrder} sort={sort} />
        </TableRow>
        <TableRow>
          <ContributorsTableHead
            label={selectedGroup ? selectedGroup.name : selectedContributorCategory.label}
            color={selectedOptionColor}
            onBackClick={onBackClick}
            dropdownColumns={groupsDropdownColumns}
            dropdownItems={groupDropdownItems}
            onDropdownItemClick={(item) => selectedGroup ? showGroup(item) : showContributorCategory(item)}
            selectedItemId={selectedGroup ? selectedGroup.id : selectedContributorCategory.id}
          />
          <TableCell align="right" style={{ color: selectedOptionColor }}>{selectedGroup ? numberFormatter(selectedGroup.totalPercentEquity * 100) : "-"}</TableCell>
          <TableCell align="right" style={{ color: selectedOptionColor }}>
            {numberFormatter(selectedGroupValue || selectedContributorValue * 100)}
          </TableCell>
        </TableRow>
      </TableHead>
      <ContributorsTableContent
        selected={selectedContributorCategory}
        openSecurityProfile={openSecurityProfile}
        openFactorProfile={openFactorProfile}
        openCompositeSecurity={openCompositeSecurity}
        data={data}
        contributorsGrouping={currentGrouping}
        selectedGroup={selectedGroup}
        showGroup={showGroup}
        groupedData={groupedData}
        page={page}
        setPage={setPage}
      />
    </Table>
  </div>
}

RiskContributors.propTypes = {
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  classifications: PropTypes.array,
  selectedContributorCategory: PropTypes.object.isRequired,
  selectedContributorValue: PropTypes.number.isRequired,
  selectedViewsFactors: PropTypes.array,
  fetchStartDate: DATE.isRequired,
  expand: PropTypes.bool.isRequired,
  viewType: PropTypes.string.isRequired,
  data: PropTypes.array,
  mustAggregateFactors: PropTypes.bool,
  sortOrder: PropTypes.object.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  showContributorCategory: PropTypes.func.isRequired,
  hideContributorCategory: PropTypes.func.isRequired,
  sort: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  setGrouping: PropTypes.func.isRequired,
  currentGrouping: PropTypes.object,
  groupedData: PropTypes.array.isRequired,
  availableRollups: PropTypes.array.isRequired,
  contributorsSummaryText: PropTypes.string.isRequired,
  csvData: PropTypes.object.isRequired,
  selectedOption: PropTypes.object.isRequired,
  selectedGroupValue: PropTypes.number,
  showNotHeld: PropTypes.bool.isRequired,
  groupBy: PropTypes.string,
  groupsDropdownColumns: PropTypes.array,
  groupDropdownItems: PropTypes.array,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
}

export default RiskContributors
